import { createContext } from 'react';

interface ThumbnailsFlags {
    seriesPageWidths: string;
}

/**
 *
 */
function createThumbnailsFlags(): ThumbnailsFlags {
/////////////////////////////////

    /**
     * Kodansha Thumbnail Flags
     */
    return {
        seriesPageWidths: "1080"
    }
//////////////////////////////////
///////
//////////////////////////////
///////
////////////
////////////////////////////////////
/////

/////////
///////
/////////////////////
///////
////////////
////////////////////////////////////////
/////

//////////
}
export const ThumbnailsFlags = createThumbnailsFlags();